import React from 'react';
import { useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  companyDataSchema,
  type CompanyDataFormData,
} from '../schemas/completeProfileSchemas';
import { useCompleteProfile } from '../contexts/CompleteProfileContext';
import useCompleteProfileMutation from '../hooks/useCompleteProfile';
import AuthFormContainer from '@/features/auth/signup/components/AuthFormContainer.tsx';
import RegisterNewCompanyCommandDto from '@/features/auth/signup/types/registerNewCompanyCommandDto.ts';
import { TextInput } from '@/components/form/TextInput.tsx';

const CompleteCompanyDataPage = () => {
  const { updateCompanyData, profileData } = useCompleteProfile();
  const { mutate: completeProfile, isPending } = useCompleteProfileMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CompanyDataFormData>({
    resolver: debugZodResolver(companyDataSchema),
  });

  const onSubmit = (data: CompanyDataFormData) => {
    const companyData = {
      companyName: data.companyName,
    };
    updateCompanyData(companyData);

    const completeSignupDto: RegisterNewCompanyCommandDto = {
      name: profileData.userDetails.name,
      surname: profileData.userDetails.surname,
      phoneNumber: profileData.userDetails.phoneNumber,
      companyName: data.companyName,
    };
    completeProfile(completeSignupDto);
  };
  return (
    <AuthFormContainer title="Uzupełnij dane firmy">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full space-y-6">
        <TextInput
          label="Nazwa firmy"
          placeholder="Wprowadź nazwę firmy"
          error={errors.companyName?.message}
          register={register('companyName')}
          required={true}
        />
        <ActionButton
          type="submit"
          tone="accent"
          size="block"
          isLoading={isPending}
        >
          Zapisz
        </ActionButton>
      </form>
    </AuthFormContainer>
  );
};

export default CompleteCompanyDataPage;
